import { Component, OnInit } from '@angular/core';
import {V3ExamSession, V3ExerciseSession} from 'src/app/cspa/model/v3/cspa';
import { SessionInfoService } from 'src/app/services/session-info.service';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  questionNb: string
  session: V3ExerciseSession | V3ExamSession
  questionCount?: number
  progressPercent?: number

  constructor(
    private progressInfoService: SessionInfoService
  ) {}

  ngOnInit(): void {
    this.progressInfoService.getSessionInfo().subscribe(i => {
      this.questionNb = i.questionNb
      this.session = i.session
      this.questionCount = i.questionCount
      this.progressPercent = i.progressPercent
    })
  }

  getExerciseProgressPercent() {
    return this.progressPercent != null ?
      this.progressPercent.toFixed()
      : ((+this.questionNb - 1) / (this.questionCount || 1) * 100).toFixed()
  }
}
